import { api } from '../utils/axios';

export const getAdminUsers = (options = {}) => async (dispatch) => {
  let data = {};
  data = {
    page: options.page,
    page_size: options.pageSize,
    filter_by: options.filterBy,
    filter_value: options.filterValue,
    sort_by: options.sortBy,
    sort_direction: options.sortDirection
  }

  dispatch({
    type: "GET_ADMIN_USERS_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_users', data);
    dispatch({
      type: "GET_ADMIN_USERS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_ADMIN_USERS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export function setPageInfo({pageSize,pageNo}){
  return {
    type : 'SET_ADMIN_USER_PAGEINFO',
    payload : {pageSize,pageNo }
  }
}

export const getUsersId = (userId) => async (dispatch) => {
     
  let data = {};
  data.target_user = {"user_id": userId}; 
  dispatch({
    type: "GET_USER_ID_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_user', data);
    dispatch({
      type: "GET_USER_ID_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_USER_ID_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getUserGroupSettings = (user) => async (dispatch) => {
  let data = {
    target_user: user
  };
  dispatch({
    type: "GET_USER_GROUP_SETTINGS_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_user_groups_settings', data);
    dispatch({
      type: "GET_USER_GROUP_SETTINGS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_USER_GROUP_SETTINGS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const createUser = (userData) => async (dispatch) => {
  
  let data = {};
  data.target_user = userData;   
  dispatch({
    type: "CREATE_USER_REQUESTED"
  });
  try {
    const response = await api.post('admin/create_user', data);
    dispatch({
      type: "CREATE_USER_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CREATE_USER_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updateUser = (userData) => async (dispatch) => {
    
    let data = {};
    data.target_user = userData;
    data.target_user.force_password_reset = userData.force_password_reset || false;
    dispatch({
      type: "UPDATE_USER_REQUESTED"
    });
    try {
      const response = await api.post('admin/update_user', data);
      dispatch({
        type: "UPDATE_USER_SUCCESS",
        response: response
      });
      return { response }
    } catch (e) {
      dispatch({
        type: "UPDATE_USER_FAILED",
        error: e.error
      });
      throw new Error(e.error);
    }
}

export const resetPasswordFunc = (userData) => async (dispatch) => {
  let data = {};
  data.target_user = userData;
  dispatch({
    type: "RESET_PASSWORD_REQUESTED"
  });
  try {
    const response = await api.post('admin/update_user', data);
    dispatch({
      type: "RESET_PASSWORD_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "RESET_PASSWORD_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const deleteUser = (userId) => async (dispatch) => {
  
  let data = {};
  data.target_user = {"user_id": userId};    
  dispatch({
    type: "DELETE_USER_REQUESTED"
  });
  try {
    const response = await api.post('admin/delete_user', data);
    dispatch({
      type: "DELETE_USER_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DELETE_USER_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const deleteUserKasm = (kasmId) => async (dispatch) => {
  
  let data = {};
  data.kasm_id = kasmId;
  dispatch({
    type: "DELETE_USER_KASM_REQUESTED"
  });
  try {
    const response = await api.post('destroy_kasm', data);
    dispatch({
      type: "DELETE_USER_KASM_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DELETE_USER_KASM_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const getAdminUsageDump = (user_id) => async (dispatch) => {
  
  let data = {"user_id": user_id};
  dispatch({
    type: "GET_USAGE_DUMP_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_user_usage_dump', data);
    dispatch({
      type: "GET_USAGE_DUMP_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_USAGE_DUMP_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}
